import React from 'react';
import Admin from './admin/Admin';

const App = () => <Admin />;

export default App;
